export default {
  'basicData': {
    'lastName': '八木',
    'firstName': '太郎',
    'lastNameFurigana': 'やぎ',
    'firstNameFurigana': 'たろう',
    'birthYear': '2002',
    'birthMonth': '5',
    'birthDay': '8',
    'sex': '1',
    'postNumber': '1040040',
    'address1': '東京都中央区築地4',
    'address2': '白山羊ビル3F',
    'addressFurigana': 'とうきょうと ちゅうおうく つきじ',
    'tel1': '03',
    'tel2': '5148',
    'tel3': '1212',
    'mobile': '',
    'fax': '',
    'email': 'taro_yagi@yagish.jp',
    'idPhotoSrc': '/static/img/id-photo-sample.jpg',
    'useContact': [''],
    'contactPostNumber': '',
    'contactAddress1': '',
    'contactAddress2': '',
    'contactAddressFurigana': '',
    'contactCareOf': '',
    'contactTel': '',
    'contactMobile': '',
    'contactFax': '',
    'contactEmail': '',
    'updateDate': ''
  },
  'formatData': {
    'createDate': new Date(),
    'formatId': 'rirekisho',
    'saveName': 'rirekisho',
    'educationalHistories': [
      {
        'year': 2018,
        'month': 3,
        'description': '市立　八木中学校 卒業',
        'uuid': '4005e384-8ce0-405b-b0f1-dea47be1a4cb'
      },
      {
        'year': 2018,
        'month': 4,
        'description': '県立　八木高等学校　普通科 入学',
        'uuid': 'e193e07f-1cf2-4930-bd52-1065f88c2c4e'
      },
      {
        'year': 2021,
        'month': 3,
        'description': '県立　八木高等学校　普通科 卒業',
        'uuid': '108c84e3-ae50-40e7-90f5-0becc48785b4'
      },
      {
        'year': 2023,
        'month': 4,
        'description': '私立　八木大学　草食部　山岳課 入学',
        'uuid': 'ef19cdf2-34f2-4076-a4bd-3381841cf987'
      },
      {
        'year': 2027,
        'month': 3,
        'description': '私立　八木大学　草食部　山岳課 卒業',
        'uuid': '99a44d4a-73c6-4440-8247-7bf14ec960bd'
      }
    ],
    'jobHistories': [
      {
        'year': '2018',
        'month': '5',
        'description': '株式会社◯◯◯◯　入社',
        'uuid': '636850ef-d6c0-4c22-91b7-bc2508c76fe4'
      },
      {
        'year': '',
        'month': '',
        'description': '現在に至る',
        'uuid': '286a59ea-e324-40e5-a09d-eea79751ba54'
      }
    ],
    'licenseHistories': [
      {
        'year': '2013',
        'month': '4',
        'description': '実用英語技能検定3級合格',
        'uuid': 'a2e09439-2c36-4981-a643-2b0f7adab257'
      },
      {
        'year': '2014',
        'month': '6',
        'description': 'TOEIC公開テスト300点取得',
        'uuid': 'd6d648f8-30dd-4c09-9367-036416723c1c'
      }
    ],
    'commuteHours': '0',
    'commuteMinutes': '40',
    'commuteDescription': '自家用車',
    'spouseNumber': '0',
    'hasSpouse': false,
    'underDutyToSupport': false,
    'reason': '前職では野生業務に携わり貴重な経験を得ましたが、もう一度牧場に戻りたいという思いが強くなりこの度貴社を志望致しました。今までの実務経験の強みを活かしながら、新しい技術に関しても積極的に勉強していきたいと考えています。',
    'request': '内定後速やかに転居可能',
    'updateDate': ''
  }
}
